/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/main.tsx`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Jost is served from our own origin (no Google Fonts request: KONTOR-ADP-001 R-04).
import '@fontsource/jost/400.css';
import '@fontsource/jost/500.css';
import '@fontsource/jost/600.css';
import '@fontsource/jost/700.css';
import '@fontsource/jost/500-italic.css';
import '@fontsource/jost/600-italic.css';
import './styles/tokens.css';
import './styles/app.css';
import './styles/defensive.css';
import './styles/agent-office.css';
import './vendor/tour.css';
import { AppProvider } from './lib/store';
import { AuthGate } from './pages/Auth';
import { App } from './App';
import { installCopy } from './lib/copy';
import { installLayoutEnhancers } from './lib/layoutEnhancers';
import { initClarity } from './lib/clarity';
import { CapturePage } from './pages/Capture';

installCopy();
installLayoutEnhancers();
initClarity(); // local event log only; the Microsoft Clarity tag is never loaded (KONTOR-ADP-001 R-04)

// Self-healing on continuous deploys: a stale chunk after a rollout reloads once instead of freezing.
window.addEventListener('vite:preloadError', () => {
  try { if (!sessionStorage.getItem('kontor-reloaded')) { sessionStorage.setItem('kontor-reloaded', '1'); location.reload(); } } catch { location.reload(); }
});

// The capture page of an upload link (ADR-050) needs no sign-in: its link carries the credential.
const capture = location.pathname === '/erfassen';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {capture ? <CapturePage /> : (
      <AuthGate>
        <AppProvider>
          <App />
        </AppProvider>
      </AuthGate>
    )}
  </StrictMode>,
);
